<template>

  <div>

    <el-card class="card-base card-shadow--medium info bg-white black-text">
      <h2>Failed Jobs</h2>
      <el-alert
          v-if="failedJobsError"
          :title="failedJobsError"
          type="error"
          :closable="false"
          show-icon
          style="margin-bottom: 20px;">
        <template slot="default">
          <p>Unable to load failed jobs. Please check if Laravel Horizon is running.</p>
        </template>
      </el-alert>
      <el-table :data="failed_jobs.jobs" style="width: 100%; min-width:500px;" v-if="!failedJobsError && failed_jobs && failed_jobs.jobs && Array.isArray(failed_jobs.jobs) && failed_jobs.jobs.length > 0">
        <el-table-column prop="job">
          <template slot="header" slot-scope="scope">
            <span>Job</span>
          </template>
          <template slot-scope="scope">
            {{ getName(scope.row.name)}}
          </template>
        </el-table-column>
        <el-table-column prop="on">
          <template slot="header" slot-scope="scope">
            <span>On</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.queue }}
          </template>
        </el-table-column>
        <el-table-column prop="tags">
          <template slot="header" slot-scope="scope">
            <span>Tags</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.payload.tags }}
          </template>
        </el-table-column>
        <el-table-column prop="failed">
          <template slot="header" slot-scope="scope">
            <span>Failed At</span>
          </template>
          <template slot-scope="scope">
            {{ momentFormat(scope.row.failed_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="runtime">
          <template slot="header" slot-scope="scope">
            <span>Runtime (sec.)</span>
          </template>
          <template slot-scope="scope">
            {{ executionTime(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="status">
          <template slot="header" slot-scope="scope">
            <span>Status</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.status }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <div class="pagin-wrp" v-if="!failedJobsError && failed_jobs && failed_jobs.total">
      <el-pagination
          :background="true"
          layout="prev, pager, next"
          :page-size="this.countNets"
          @current-change="chosePage"
          :total="failed_jobs.total"
      >
      </el-pagination>
    </div>
  </div>

</template>

<script>
import {mapGetters} from "vuex";
import moment from 'moment-timezone'

export default {
  name: "FailedJobs",
  data() {
    return {
      countNets: 50,
      chosenPage: 1,
      startingAt:-1,
      timer:'',
    }
  },
  computed: {
    ...mapGetters({
      failed_jobs: 'monitor/getFailedJobs',
      failedJobsError: 'monitor/getFailedJobsError',
    })
  },
  mounted () {
    this.updateFailedJobsList();
    this.timer = setInterval(this.updateFailedJobsList, 3000);
  },
  methods: {
    cancelAutoUpdate () {
      clearInterval(this.timer);
    },

    momentFormat(date) {
      return moment.tz(parseInt(date*1000),this.$moment.tz.guess()).format('MM/DD/YYYY hh:mm')
    },
    getName(str) {
      let lastSlash = str.lastIndexOf('\\');
      return str.substring(lastSlash+1);
    },
    executionTime(data){
      let worktime = 0
      switch(data.status) {
        case 'completed':
          worktime = (data.completed_at?data.completed_at:data.reserved_at)- data.reserved_at;
          break;
        case 'failed':
          worktime = (data.failed_at ?data.failed_at: data.reserved_at) - data.reserved_at;
          break;
        default:
          worktime;
      }
      return worktime.toFixed(2)
    },
    chosePage (e) {
      this.chosenPage = e
      if(this.chosenPage==1){
        this.startingAt=-1;
      }else{
        this.startingAt =this.chosenPage*this.countNets;
      }
      this.updateFailedJobsList()
    },

    updateFailedJobsList(){
      let params = ''
      params = `starting_at=${this.startingAt}`
      if (this.countNets) {
        params = `${params}&limit=${this.countNets}`
      }

      this.$store.dispatch('monitor/getFailedJobs', params);
    }

  },
  beforeDestroy () {
    this.cancelAutoUpdate();
  }
}
</script>

<style >
.el-row {
  margin-bottom: 20px;

}
.el-row:last-child {
  margin-bottom: 0;
}

.el-col {
  border-radius: 5px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 5px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>